import Components from "./AllComponent";
import Bodies from "./body";
import Header from "./header";

function App() {

  return (
    <>
    <Components />
   </>
  );
}

export default App;
// min-h-screen bg-cover bg-center bg-no-repeat flex flex-col
// min-h-screen bg-cover bg-no-repeat flex items-center justify-between px-8